"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var ResultCtaBanner = function ResultCtaBanner(_ref) {
  var children = _ref.children,
      use = _ref.use;
  var classes = (0, _classnames.default)({
    'cta-icon': true,
    'icon-trophy': use === 'trophy',
    'icon-mobile': use === 'mobile',
    'icon-locked': use === 'lock',
    'icon-search': use === 'search'
  });
  return _react.default.createElement("div", {
    className: "result-cta-container"
  }, _react.default.createElement("div", {
    className: "result-cta-banner"
  }, _react.default.createElement("div", {
    className: classes
  }), _react.default.createElement("div", {
    className: "cta-info"
  }, children)));
};

ResultCtaBanner.propTypes = {
  children: _propTypes.default.node.isRequired,
  use: _propTypes.default.string.isRequired
};
var _default = ResultCtaBanner;
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./js/components/ResultCtaBanner.js
// module id = 72
// module chunks = 0